import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const InlineVideo = () => {
	const block = document.querySelectorAll(".inline-video");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);

	block.forEach((element) => {
		const isMobile = window.innerWidth < 768;
		const disableAutoplay = element.classList.contains("inline-video_disable-autoplay") && !isMobile;
		const video = element.querySelector("video");
		const control = element.querySelector(".inline-video__control");
		const playToggle = element.querySelector(".inline-video__toggle");

		if (playToggle) {
			playToggle.addEventListener("click", (e) => {
				playToggle.classList.toggle("active");

				if (video.classList.contains("playing")) {
					video.pause();
					video.muted = true;
					video.classList.remove("playing");
				} else {
					video.muted = false;
					video.classList.add("playing");
					video.play();
				}
			});
		}

		const mutedAllVideos = () => {
			document.querySelectorAll(".inline-video").forEach((el) => {
				const video = el.querySelector(".inline-video__el");
				const control = el.querySelector(".inline-video__control");

				video.muted = true;
				video.classList.remove("muted");
				if (control) {
					control.classList.remove("active");
				}
			});
		};

		const pauseAllVideos = () => {
			document.querySelectorAll(".inline-video").forEach((el) => {
				const video = el.querySelector(".inline-video__el");
				const toggle = el.querySelector(".inline-video__toggle");

				video.pause();
				video.muted = true;
				video.classList.remove("playing");
				toggle.classList.remove("active");
			});
		}

		document.addEventListener("modal-closed", () => {
			pauseAllVideos();
		});

		const handlePlayVideo = () => {
			gsap.timeline({
				scrollTrigger: {
					trigger: element,
					start: "top bottom",
					scrub: true,
					onEnter: () => {
						video.play();
						video.classList.add("playing");
					},
					onEnterBack: () => {
						video.play();
						video.classList.add("playing");
					},
					onLeave: () => {
						if (video.classList.contains("playing")) {
							video.pause();
							video.setAttribute("muted", "muted");
							video.classList.remove("playing");
						}
					},
					onLeaveBack: () => {
						if (video.classList.contains("playing")) {
							video.pause();
							video.setAttribute("muted", "muted");
							video.classList.remove("playing");
						}
					}
				}
			});
		};

		if (!disableAutoplay) {
			handlePlayVideo();

			document.addEventListener("inline-video-refresh", (e) => {
				handlePlayVideo();
			});
		}

		if (control) {
			control.addEventListener("click", (e) => {
				if (video.classList.contains("muted")) {
					video.muted = true;
					video.classList.remove("muted");
				} else {
					mutedAllVideos();
					video.muted = false;
					video.classList.add("muted");
				}
				e.target.classList.toggle("active");
			});
		}
	});
};

export default InlineVideo;
